import { iconDefaults, type IconProps } from './Icon'

export function InfoIcon(props: IconProps) {
  return (
    <svg {...iconDefaults} {...props}>
    <circle cx="12" cy="12" r="9" />
    <path d="M12 11v5.5M12 7.6v.2" />
    </svg>
  )
}
